import React from 'react';

const Navigation = ({ 
  isMenuOpen, 
  onClose, 
  isDarkMode, 
  toggleDarkMode, 
  isEasyMode, 
  setIsEasyMode,
  setYearSelectionStep 
}) => {
  const handleModeToggle = () => {
    setIsEasyMode(!isEasyMode);
    onClose();
  };

  const handleYearSelect = () => {
    setYearSelectionStep(true);
    onClose();
  };

  return (
    <>
      {/* Add menu overlay */}
      <div 
        className={`menu-overlay ${isMenuOpen ? 'visible' : ''}`} 
        onClick={onClose}
      />
      <nav 
        className={`navigation-menu ${isMenuOpen ? 'open' : ''}`}
        role="navigation"
        aria-label="Main menu"
      >
        <div className="menu-content">
          <button 
            className="menu-item"
            onClick={handleModeToggle}
          >
            {isEasyMode ? 'Switch to Hard Mode' : 'Switch to Easy Mode'}
          </button>
          <button 
            className="menu-item"
            onClick={handleYearSelect}
          >
            Choose Year Range
          </button>
          <button 
            className="menu-item"
            onClick={() => {
              toggleDarkMode();
              onClose();
            }}
          >
            {isDarkMode ? 'Light Mode' : 'Dark Mode'}
          </button>
          <a 
            href="https://crossovergrid.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="menu-item"
            onClick={onClose}
          >
            CrossoverGrid
          </a>
        </div>
      </nav>
    </>
  );
};

export default Navigation; 